import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { getAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationFollowup = ({ entry }) => {
    const authorName = getAuthorName(entry);
    const authorLink = authorName ? (_jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName }))) : null;
    const action = useCallback(() => {
        switch (entry.activity_type) {
            case 'FOLLOWUP_ADDED':
                return 'set';
            case 'FOLLOWUP_EXPIRED':
                return 'expired';
            case 'FOLLOWUP_REMOVED':
                return 'cancelled';
            default:
                console.warn(`Unknown follow-up type ${entry.activity_type}`);
                return 'unknown';
        }
    }, [entry]);
    const text = (_jsxs(_Fragment, { children: ["Follow-up is ", action(), " ", authorLink && _jsxs(_Fragment, { children: ["by ", authorLink] })] }));
    return _jsx(LogEntry, { entry: entry, text: text });
};
